import React, { lazy,useState, useEffect  } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory, useParams } from 'react-router-dom';
import { Form, Row, Col, Card, Modal, Input, Select, Table, Spin, Tooltip, DatePicker, Radio, Checkbox, notification } from 'antd';
import { PageHeader } from '../../../components/page-headers/page-headers';
import FontAwesome from 'react-fontawesome';
import FeatherIcon from 'feather-icons-react';

import { Button } from '../../../components/buttons/buttons';
import { Main, BasicFormWrapper,TableWrapper } from '../../styled';
import { Cards } from '../../../components/cards/frame/cards-frame';
import { RecordFormWrapper } from './Style';

import { membresiasListListAction, membresiasListSelectBoxAction, membresiaCreateAction } from '../../../redux/membresia/actionCreator'

import {estadosListAction, municipioListAction} from '../../../redux/catalogos/actionCreator';
import { sucursalListAction } from '../../../redux/administracion/sucursales/actionCreator';


const MembresiasView = ({setSubmenu}) => {
  
  const { id } = useParams();

  const dispatch = useDispatch();    
  const isLoading = useSelector(state => state.responseReducer.loading);
  const registros = useSelector(state => state.MembresiaCrudReducer.data);
  const catalogoMembresias = useSelector(state => state.MembresiaCrudReducer.dataSelectBox);
  const catalogoFormasPago = useSelector(state => state.CatalogosReducer.formasPago);

  const catalogoEstados = useSelector(state => state.CatalogosReducer.estados);
  const catalogoMunicipios = useSelector(state => state.CatalogosReducer.municipios);
  const catalogoSucursales = useSelector(state => state.SucursalReducer.dataSelectBox);
  const catalogoTipoOrigenes = useSelector(state => state.CatalogosReducer.tipoOrigenes);
  const catalogoGeneros = useSelector(state => state.CatalogosReducer.generos);
  const catalogoEstadosCivil = useSelector(state => state.CatalogosReducer.estadosCivil);
  const catalogoRegimenFiscal = useSelector(state => state.CatalogosReducer.regimenFiscal);

  const [modalVisible, setModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [formBeneficiarios] = Form.useForm();
  
  const [ showForm, setshowForm ] = useState( false )

  const dataSource = [];

  const [dataBeneficiarios, setDataBeneficiarios] = useState([]);

  useEffect(() => {

    if (id) {
       dispatch(membresiasListListAction(id));
       dispatch(membresiasListSelectBoxAction());
    }
  }, [id]);

const showModal = () => {
    form.resetFields();
    setshowForm(false)
    setModalVisible(true);
    setDataBeneficiarios([])
}

const onInputChange = async (values) => { 
  
  formBeneficiarios.resetFields();

  values == 9 ? setshowForm(true) : setshowForm(false)

  if(values.idServicio == 9){ notification.info({message: "Puedes agregar máximo 5 beneficiarios." }); }

  dispatch(estadosListAction());
  dispatch(sucursalListAction());

}
const handleAdd = (values) => { 
  
  setshowForm(false)
  formBeneficiarios.resetFields();

  setDataBeneficiarios([
    ...dataBeneficiarios, 
    values
   ])

}
const hideFormBeneficiario = (values) => { 
  setshowForm(false)
}

const handleDelete = (folio_historico) => { 
  
   let filteredArray = dataBeneficiarios.filter(item => item?.folio_historico !== folio_historico)
   setDataBeneficiarios(filteredArray);

}

const handleAddOther = (values) => { 
  formBeneficiarios.resetFields();

  if(dataBeneficiarios.length >= 5){
    notification.info({  message: "Lo sentimos solo puedes agregar 5 beneficiarios." });
  }else{
    setshowForm(true) 
  }
   
}

const handleSubmit = async (values) => { 

  const params = {
    id: id,
    folio:         values.folio,
    idFormaPago:   values.idFormaPago,
    idServicio:    values.idServicio,
    beneficiarios: dataBeneficiarios
  }

  console.log(params);

  if(values.idServicio == 9 && dataBeneficiarios.length <=0){
    notification.info({  message: "Si la membresia es Familiar tienes que agregar al menos un beneficiario." });
  }else{

    const responseApi = await dispatch(membresiaCreateAction({
      ...params
     }));    
    if (responseApi) {
      notification.success({  message: 'La membresia se registro exitosamente.' });
      
      form.resetFields();
      setshowForm(false)
      setModalVisible(false);

      if (id) {
        dispatch(membresiasListListAction(id));
      }

    } else {
      notification.error({ message: 'Error al registrar la membresia del paciente.' });
    }
  }
};

const loadCatalogoMunicipios = idEstado => {
  if (municipioListAction) {
    dispatch(municipioListAction(idEstado));
  }
};

if (dataBeneficiarios.length)
dataBeneficiarios.map((record, key) => {      
      const { id, folio_historico, nombre, paterno, materno } = record; // Aqui se mapean las propiedades/columnas que el API respondera
      return dataSource.push({
        key: key + 1,
        folio_historico,                 
        nombre,                 
        paterno,                 
        materno,                 
        action: (
          <div className="table-actions">
            <Tooltip title="Agregar beneficiario" color="#f8f9ac">
                <Button onClick={handleAddOther}>
                  <FeatherIcon icon="edit-2" />
                </Button>
            </Tooltip>
            &nbsp;&nbsp;
            <Tooltip title="Eliminar beneficiario" color='#f8f9ac'>
                 <Button onClick={() => handleDelete(folio_historico)}>
                  <FeatherIcon icon="trash-2" />
                </Button>
            </Tooltip>                                             
          </div>
        ),
      });
    });

  const columns = [
    {
      title: 'Folio',
      dataIndex: 'folio_historico',
      key: 'folio_historico',
    },   
    {
      title: 'Nombre beneficiario',
      dataIndex: 'nombre',
      key: 'nombre',
    },   
    {
      title: 'Paterno beneficiario',
      dataIndex: 'paterno',
      key: 'paterno',
    },   
    {
      title: 'Materno beneficiario',
      dataIndex: 'materno',
      key: 'materno',
    },   
    {
      title: 'Acciones',
      dataIndex: 'action',
      key: 'action',
      width: '90px',
    },
  ];

  return (
    <>
    
      <Main>

      <Card>
        <PageHeader
          title="Membresias: "
          subTitle={ registros.length > 0 ? registros[0].nombrePaciente + ' ' + registros[0].paternoPaciente + ' ' + registros[0].maternoPaciente: '' }
          buttons={[
            <Button className="btn-add_new noprint" size="default" key="1" type="primary" onClick={ showModal }>
               Registrar membresia
            </Button>,
            <Button className="btn-add_new noprint" size="default" key="2" type="primary">
               <Link to={`/admin/clinica/pacientes/expediente/${id}`}> Volver al expediente</Link> 
          </Button>,
          ]}
        />
      </Card>

      <Row gutter={16} style={{ width: '100%', marginTop: '1em' }}>

      {
          registros.map(element => {
              return (
                     <Col className="gutter-row" span={6} key={ element.id } >{/*  extra={<a href="#">Ver detalle</a>}   */}
                         <Card title={ element.nombreServicio }style={{ width: '100%', marginBottom: '1em' }}>
                              <p>    
                                <FontAwesome name="folder" />      <small>Folio: {element.folio ? element.folio : '---'}</small> <br />
                                <FontAwesome name="calendar" />    <small>Fecha inicio: {element.fecha_inicio_vigencia}</small> <br />
                                <FontAwesome name="calendar" />    <small> Fecha vigencia: {element.fecha_fin_vigencia}</small> <br />
                                <FontAwesome name="credit-card" /> <small>Precio: {element.costo_membresia}</small> 
                              </p>
                        </Card>
                    </Col>
               );
          })
      }

    </Row>
      </Main>

      <Modal title="Registrar membresia" centered visible={modalVisible} onCancel={() => setModalVisible(false)} width='60%' footer={[]} maskStyle={{ keyboard:false, backdrop: 'static'}} >
                <Row gutter={24}>
                    <Col md={24} lg={24} sm={24}>
                        
                    <Form layout="vertical" size="small"  form={form}  onFinish={handleSubmit}  style={{ display: !showForm ? 'block' : 'none' }}>
              
              <RecordFormWrapper>
                <Cards headless>
                  <BasicFormWrapper>                  
              
          <Form.Item >
            <Input.Group compact>

                <Form.Item name="idServicio" label="Selecciona la mebresia" rules={[{ required: true, message: 'Campo obligatorio.'}]}>
                     <Select placeholder="Selecciona..." options={catalogoMembresias} notFoundContent={'Sin registros'} style={{ width: '250px', margin: '0 7px', height:'10px!important' }} onChange={ onInputChange }/>
                </Form.Item>

                <Form.Item name="idFormaPago" label="Forma de pago" rules={[{ required: true, message: 'Campo obligatorio.' }]}>
                     <Select placeholder="Selecciona..." options={catalogoFormasPago} notFoundContent={'Sin registros'} style={{ width: '250px', margin: '0 7px', height:'10px!important' }} />
                </Form.Item>

                <Form.Item name="folio" label="Folio membresia" rules={ [{ pattern: "^[0-9]*$", message: 'Solo se aceptan números.' }, { message: 'Campo obligatorio.', required: true }] }>
                      <Input size="large" placeholder="Ej. 204544"  style={{ width: '130px', height: '100px', margin: '0 7px', height:'10px!important' }}/>
              </Form.Item> 

            </Input.Group>
          </Form.Item> 

               <div style={{ display: dataSource.length > 0 ? 'block' : 'none' }}>
                    <div className="record-form-actions text-right" style={{marginBottom: '1em'}}>
                        <Button size="small" type="primary" onClick={handleAddOther}>  <FeatherIcon icon="plus" /> Agregar beneficiario </Button>
                     </div>
                  <TableWrapper className="table-data-view table-responsive">
                  
                    <Table
                      pagination={{ pageSize: 40, showSizeChanger: true }}
                      dataSource={dataSource}
                      columns={columns}
                      locale={{ emptyText: 'Sin registros' }}
                    />
                  </TableWrapper>
                </div>

                  </BasicFormWrapper>

                  <br />
                  <div className="record-form-actions text-right" style={{ display: !showForm ? 'block' : 'none' }}>
                    <Button size="default" htmlType="Save" type="primary">
                      {isLoading ? 'Cargando...' : 'Guardar'}
                    </Button>
                  </div>
                </Cards>
              </RecordFormWrapper>
            </Form>

        <Form layout="vertical" size="small"  form={formBeneficiarios} onFinish={handleAdd}  style={{ display: showForm ? 'block' : 'none' }}>

          <Form.Item>
            <Input.Group compact>
              <Form.Item
                name="idTipoOrigen"
                label="Origen"
                rules={[{ message: 'Campo obligatorio', required: true }]}
              >
                <Select placeholder="Origen" options={catalogoTipoOrigenes} notFoundContent={'Sin registros'} style={{ width: '250px', margin: '0 7px' }} />
              </Form.Item>
              <Form.Item name="idSucursalOrigen" label="Sucursal de orígen" rules={[{ message: 'Campo obligatorio', required: true }]}>
                <Select placeholder="* Sucursal de orígen" options={catalogoSucursales} notFoundContent={'Sin registros'} style={{ width: '250px', margin: '0 7px' }} />
              </Form.Item>

              <Form.Item
                name="folio_historico"
                label="Folio historico"
                rules={[{ message: 'Campo obligatorio', required: true }]}
              >
                <Input style={{ width: '250px' }} />
              </Form.Item>

            </Input.Group>
          </Form.Item>

          <Form.Item>
            <Input.Group compact>
              <Form.Item
                name="nombre"
                label="Nombre(s)"
                rules={[{ message: 'Campo obligatorio', required: true }]}
              >
                <Input style={{ width: '250px', margin: '0 7px' }} />
              </Form.Item>
              <Form.Item
                name="paterno"
                label="Apellido paterno"
                rules={[{ message: 'Campo obligatorio', required: true }]}
              >
                <Input style={{ width: '250px', margin: '0 7px' }} />
              </Form.Item>
              <Form.Item
                name="materno"
                label="Apellido materno"
                rules={[{ message: 'Campo obligatorio', required: true }]}
              >
                <Input style={{ width: '250px' }} />
              </Form.Item>
            </Input.Group>
          </Form.Item>
          
          <Form.Item>
            <Input.Group compact>
              <Form.Item
                name="genero"
                label="Genero"
                rules={[{ message: 'Campo obligatorio', required: true }]}
              >
                <Select placeholder="Selecciona" options={catalogoGeneros} notFoundContent={'Sin registros'} style={{ width: '250px', margin: '0 7px' }} />
              </Form.Item>
              <Form.Item name="fecha_nacimiento" label="Fecha de nacimiento (dd-mm-yyyy)" rules={[{ required: false }, {
                pattern: /^\d{2}-\d{2}-\d{4}$/,
                message: 'Escríbe la fecha en el formato indicado',
              },]} >
                <Input placeholder='Ej. 02-28-1980' style={{ width: '250px' }} />

              </Form.Item>
            </Input.Group>
          </Form.Item>

          <Form.Item>
            <Input.Group compact>
              <Form.Item
                name="telefono_movil"
                label="Teléfono móvil"
                rules={[{ message: 'Campo obligatorio', required: true }, { pattern: "^[0-9]*$", message: 'Solo se aceptan números.' }, { max: 10, message: 'Solo se aceptan 10 dígitos.' },  { min: 10, message: 'El número debe contener 10 dígitos.' }]}
              >
                <Input placeholder="ddd" style={{ width: '250px', margin: '0 7px' }} />
              </Form.Item>
              <Form.Item
                name="telefono_particular"
                label="Teléfono particular"
                rules={[{ pattern: "^[0-9]*$", message: 'Solo se aceptan números.' }, { max: 10, message: 'Solo se aceptan 10 dígitos.' },  { min: 10, message: 'El número debe contener 10 dígitos.' }]}>
                <Input style={{ width: '200px', margin: '0 7px' }} />
              </Form.Item>
              <Form.Item
                name="telefono_laboral"
                label="Teléfono laboral"
                rules={[{ pattern: "^[0-9]*$", message: 'Solo se aceptan números.' }, { max: 10, message: 'Solo se aceptan 10 dígitos.' },  { min: 10, message: 'El número debe contener 10 dígitos.' }]}
              >
                <Input style={{ width: '200px', margin: '0 7px' }} />
              </Form.Item>
              <Form.Item
                name="email"
                label="Correo electrónico"
                rules={[{ message: 'Campo obligatorio', required: true }, { pattern: "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$", message: 'Correo inválido.' }, { max: 50, message: 'Solo se aceptan 10 dígitos.' },  { min: 5, message: 'El número debe contener 10 dígitos.' }]}
              >
                <Input style={{ width: '250px', margin: '0 7px' }} />
              </Form.Item>
            </Input.Group>
          </Form.Item>

          <Form.Item>
            <Input.Group compact>
              <Form.Item name="calle" label="Calle" rules={[{ required: false }]}>
                <Input style={{ width: '250px', margin: '0 7px' }} />
              </Form.Item>
              <Form.Item name="numero" label="Número" rules={[{ required: false }]}>
                <Input style={{ width: '200px', margin: '0 7px' }} />
              </Form.Item>
              <Form.Item name="colonia" label="Colonia" rules={[{ message: 'Campo obligatorio', required: true }]}>
                <Input style={{ width: '250px', margin: '0 7px' }} />
              </Form.Item>
              <Form.Item name="codigo_postal" label="Código postal" rules={[{ required: false },{ pattern: "^[0-9]*$", message: 'Solo se aceptan números.' }, { max: 5, message: 'Solo se aceptan 5 dígitos.' },  { min: 5, message: 'El número debe contener 5 dígitos.' }]}>
                <Input placeholder="Código postal" style={{ width: '150px' }} />
              </Form.Item>
            </Input.Group>
          </Form.Item>

          <Form.Item>
            <Input.Group compact>
              <Form.Item
                name="idEstado"
                label="Estado"
                rules={[{ message: 'Campo obligatorio', required: true }]}
              >
                <Select
                  options={catalogoEstados}
                  onSelect={e => loadCatalogoMunicipios(e)}
                  notFoundContent={'Sin registros'}
                  style={{ width: '245px', margin: '0 7px' }}
                />
              </Form.Item>
              <Form.Item
                name="idMunicipio"
                label="Municipio"
                rules={[{ message: 'Campo obligatorio', required: true }]}
              >
                <Select
                  options={catalogoMunicipios}
                  notFoundContent={'Selecciona un estado'}
                  style={{ width: '245px' }}
                />
              </Form.Item>
            </Input.Group>
          </Form.Item>

          <Form.Item>
            <Input.Group compact>
              <Form.Item
                name="estado_civil"
                label="Estado civil"
              >
                <Select options={catalogoEstadosCivil} notFoundContent={'Sin registros'} style={{ width: '250px', margin: '0 7px' }} />
              </Form.Item>
              <Form.Item
                name="ocupacion"
                label="Ocupación"
              >
                <Input style={{ width: '300px' }} />
              </Form.Item>
            </Input.Group>
          </Form.Item>

          <Form.Item>
            <Input.Group compact>
              <Form.Item
                name="rfc"
                label="RFC"
              >
                <Input style={{ width: '250px', margin: '0 7px' }} />
              </Form.Item>
              <Form.Item
                name="razon_social"
                label="Razón social"
              >
                <Input style={{ width: '400px', margin: '0 7px' }} />
              </Form.Item>
            </Input.Group>
          </Form.Item>

          <Form.Item>
            <Input.Group compact>
              <Form.Item
                name="regimen_fiscal"
                label="Regimen fiscal"
              >
                <Select placeholder="Selecciona..." options={catalogoRegimenFiscal} notFoundContent={'Sin registros'} style={{ width: '500px', margin: '0 12px' }} />
              </Form.Item>
              <Form.Item name="codigo_postal_fiscal" label="Código postal fiscal" rules={[{ required: false },{ pattern: "^[0-9]*$", message: 'Solo se aceptan números.' }, { max: 5, message: 'Solo se aceptan 5 dígitos.' },  { min: 5, message: 'El número debe contener 5 dígitos.' }]}>
                <Input style={{ width: '150px' }} />
              </Form.Item>
            </Input.Group>
          </Form.Item>

          <Form.Item name="idEstatus" label="Estatus de la cuenta" rules={[{ message: 'Campo obligatorio', required: true }]}>
            <Radio.Group>
              <Radio value="1">
                Paciente activo
              </Radio>
              <Radio value="2">
                Paciente suspendido
              </Radio>
              <Radio value="3">
                Paciente dado de baja
              </Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item name="id" initialValue="0" noStyle>
              <Input hidden />
          </Form.Item>

          <br />
          <div className="record-form-actions text-right">
            <Button size="default" htmlType="Save" type="primary" style={{marginRigth: '3em'}}>
              {isLoading ? 'Cargando...' : 'Agregar'}
            </Button>
            <Button size="default" type="danger" onClick={ hideFormBeneficiario }>
              Cancelar
            </Button>
          </div>

        </Form>

 
 


                    </Col>
                </Row>
            </Modal>

    </>
  );
};

export default MembresiasView;
